import { differentials } from '../../data/content';
import './Differentials.css';

function Differentials() {
  return (
    <section id="diferenciais" className="section differentials">
      <div className="container">
        <div className="section-header">
          <h2>O diferencial Borelli</h2>
        </div>

        <div className="diff-grid">
          {differentials.map((item) => (
            <div key={item} className="diff-item">
              <span className="diff-check">✔</span>
              <span>{item}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Differentials;
